<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-03 10:56:46
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-05 11:07:15
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\components\rulesOper.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="rules-oper">
		<div class="item flex-row">
			<p class="label mr-24 yx-color-text-primary font-h4-regular">
				<span>自动同步样品协作申请</span>
			</p>
			<div class="mt-2">
				<el-switch v-model="form.contentStatus" inactive-color="#E2E3E8" :active-value="1" :inactive-value="0"></el-switch>
				<div class="collaborate-content flex-row flex-align-center font-h6-regular mt-8 radius-4" v-if="form.contentStatus">
					<span class="mr-2">样品协作内容</span>
					<Explain :content="content" placement="top" size="14" class="explain mr-12" classStyle="yx-color-blue-6" />
					<el-select v-model="form.contentType" popper-class="option-list" clearable placeholder="请选择">
						<el-option v-for="(item, index) in collaborateList" :key="index" :label="item.label" :value="item.value" />
					</el-select>
				</div>
			</div>
		</div>
		<div class="item flex-row flex-align-start" style="margin-top: 32px">
			<div class="label mr-24 yx-color-text-primary font-h4-regular">
				<p>协作申请可展示达人信息</p>
				<p class="yx-color-text-secondary font-h6-regular">(昵称/头像默认展示)</p>
			</div>
			<div class="checkbox-group">
				<el-checkbox-group v-model="form.dataAuthority">
					<span v-for="(item, index) in enumerationList" :key="item.value" class="">
						<el-checkbox :label="item.value">{{ item.label }}</el-checkbox>
						<br v-if="index === 2" />
					</span>
				</el-checkbox-group>
			</div>
		</div>

		<div class="item flex-row flex-align-start" style="margin-top: 18px">
			<p class="label mr-24 yx-color-text-primary font-h4-regular">
				<span>手动同步样品交付视频给商家</span>
				<span class="yx-color-text-secondary ml-4 cursor-pointer" @click="openRules">《规则说明》</span>
			</p>
			<div class="mt-2">
				<el-switch v-model="form.isSyncVideo" inactive-color="#E2E3E8" :active-value="1" :inactive-value="0"></el-switch>
			</div>
		</div>
		<ruleExplainDialog ref="ruleExplainDialog">
			<p>开关开启后招商可在【合作进度-开播表】手动将合作进度关联的交付视频同步给商家；</p>
		</ruleExplainDialog>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import ruleExplainDialog from '@/components/business/ruleItem/ruleExplainDialog.vue';
export default {
	components: {
		Explain,
		ruleExplainDialog,
	},
	props: {
		rules: {
			type: Object,
			default: () => {},
		},
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_DY.value,
		},
	},
	computed: {
		enumerationList({ platformId }) {
			const isDy = +platformId === +dataMap.PLATFORM_DY.value;
			const formatPlatformName = this.$options.filters.formatPlatformName;
			const arr = [
				{
					label: formatPlatformName(platformId, 'suf'),
					value: 'anchor_account',
					isShow: true,
				},
				{
					label: '带货等级',
					value: 'anchor_level',
					isShow: isDy,
				},
				{
					label: '粉丝量',
					value: 'fans_num',
					isShow: true,
				},
				{
					label: '场均销售额',
					value: 'live_sale',
					isShow: true,
				},
				{
					label: '30日销售额',
					value: 'fee_30',
					isShow: true,
				},
			];
			return arr.filter(v => v.isShow);
		},
		content({ form }) {
			const obj = {
				1: '待审核状态样品订单即可发起协作申请，商家可协作处理审核、发货操作；',
				2: '仅待发货状态样品订单可发起协作申请，商家可协作处理发货操作；',
			};
			return obj[form.contentType];
		},
	},
	watch: {
		form: {
			handler(to) {
				this.$emit('handleFormChange', to);
			},
			deep: true,
		},
		rules: {
			handler(to) {
				Object.keys(to).forEach(key => (this.form[key] = to[key]));
			},
			deep: true,
			immediate: true,
		},
	},
	data() {
		return {
			collaborateList: [
				{ label: '审核+发货', value: 1 },
				{ label: '发货', value: 2 },
			],
			form: {
				contentStatus: 0,
				isSyncVideo: 0,
				dataAuthority: [],
				contentType: 1,
			},
		};
	},
	methods: {
		openRules() {
			this.$refs.ruleExplainDialog.show();
		},
	},
};
</script>
<style lang="less" scoped>
.item {
	.label {
		width: 280px;
		text-align: right;
		flex-shrink: 0;
	}
	.collaborate-content {
		background-color: #f7f8fa;
		padding: 12px;
		::v-deep .el-input--small {
			width: 280px;
			font-size: 12px;
		}
	}
	.checkbox-group {
		::v-deep .el-checkbox {
			width: 130px;
			margin-bottom: 12px;
		}
	}
}
</style>
<style lang="less">
.option-list {
	.el-select-dropdown__item {
		font-size: 12px !important;
	}
}
</style>
